// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"navbarcenter_wrapper__3Ahbk"};